let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6iCxM")).then(() => parcelRequire('49EkV'));